import { render, staticRenderFns } from "./einstellungen.vue?vue&type=template&id=975c47bc&"
import script from "./einstellungen.vue?vue&type=script&lang=js&"
export * from "./einstellungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports